import { FormBuilder, FormArray, FormControl, AbstractControl, FormGroup } from '@angular/forms'
import { NdmsFormControlComponent, ControlState } from '../ndms-form-control/ndms-form-control.component';
import {Component, OnInit, ViewContainerRef, Input, ElementRef, ViewChild, Injector, Pipe} from '@angular/core';
import { SsnMaskPipe } from '../../pipes/ssn-mask.pipe';
import { Last4MaskPipe } from '../../pipes/last4-mask.pipe';
import { PipeResolver } from '@angular/compiler';

@Component({
  selector: 'ndms-textbox',
  templateUrl: './ndms-textbox.component.html',
  styleUrls: ['./ndms-textbox.component.scss']
})

export class NdmsTextboxComponent extends NdmsFormControlComponent implements OnInit {

  @Input() field: string;
  @Input() group: FormGroup;
  @Input() array: string;

  @Input() size: string;
  @Input() placeholder: string;
  @Input() length: number;

  @Input() label: string;
  @Input() labelHidden: boolean;

  @Input() readonly: boolean;
  @Input() isEditing: () => boolean;

  @Input() required: string;
  @Input() pipeName: string;

  @Input() focus: boolean = false;

  pipe: any; 

  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
  }

  ngOnInit() {}

  canAddArrayItem(currentIndex: number) {
    return true;
  }

  getPipedText() {
    //if(this.text) 
      //return this.text;   

    let field = this.group.get(this.field);
    if(!field) 
      throw `Field "${this.field}" is missing from the form group`;   

    // this.pipe = new Pipe('ssnMask');
    if(this.pipeName=='SsnMaskPipe')
        this.pipe = new SsnMaskPipe();
    else
    if(this.pipeName=='Last4MaskPipe')
        this.pipe = new Last4MaskPipe();
    else
        return field.value;

    return this.pipe.transform( field.value, );
  }

}


